import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { HeadCell, tableSchema } from "../Schema/schema";
import TableStyle from "../TableStyle";
import FilterOptions from "../Filter/Filter";
import RootState from '../../../redux/types/rootState';
import { useShallowSelector } from '../../../hooks/useShallowSelector';
import CircularProgress from '@mui/material/CircularProgress';

export const TableHeader = ({
  isChecked,
  toggleAllCheckboxes,
}: {
  isChecked: boolean;
  toggleAllCheckboxes: React.ChangeEventHandler<HTMLInputElement> | undefined;
}) => {
  const classes = TableStyle();
  const isSelectableBookingLoading = useShallowSelector(
    (state: RootState) => state.bookings.isSelectableBookingLoading
  );
  return (
    <TableHead>
      <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableCellHead}>
          {isSelectableBookingLoading ? <CircularProgress size={16}/> :
          <input
            type="checkbox"
            checked={isChecked}
            onChange={toggleAllCheckboxes}
            className={classes.checkboxAll}
          />
          }

        </TableCell>
        {headCellCreator(tableSchema)}
      </TableRow>
    </TableHead>
  );
};

const headCellCreator = (headCells: HeadCell[]) => {
  const classes = TableStyle();
  return (
    <>
      {headCells.map((headCell) => {
        return (
          <TableCell
            key={headCell.id + "-key"}
            id={headCell.id}
            className={classes.tableCellHead}
          >
            <span className="headText">{headCell.text}</span>
            {headCell.filter ? (
              <FilterOptions filterColumnTypes={headCell.filterType!} />
            ) : (
              <></>
            )}
          </TableCell>
        );
      })}
    </>
  );
};
